import React, { useEffect, useRef, useState } from "react"
import { useDispatch } from "react-redux";
import { baseRequest } from "../../../fetch/basicThunk";
import { QUERY_POST_TAXONOMY } from "../../../fetch/constantQueries";
import deleteIcon from "../../../images/delete.svg"
import SelectBox from "../../common/CustomSelectBox"

const initialValueValues = {
    level: 1,
    taxonomyLevel_1: null,
    taxonomyLevel_2: null,
    taxonomyLevel_3: null,
    taxonomyLevel_4: null
}

const initialTaxonomyOptions = {
    level_1 : null,
    level_2 : null,
    level_3:  null,
    level_4:  null
}

function TaxonomySelector(props)
{
    const {selectedTaxonomy, index, handleTaxonomiesChange, handleDeleteTaxonomy} = props;
    const [taxonomyOptions, setTaxonomyOptions] = useState(initialTaxonomyOptions)
    const [selectedValues, setSelectedValues] = useState(initialValueValues)
    const dispatch = useDispatch();
    const valueLevel2 = useRef()
    const valueLevel3 = useRef()
    const valueLevel4 = useRef()

    useEffect(()=>{
        if(selectedTaxonomy)
        {
           fetchTaxonomyValues(initialValueValues, selectedTaxonomy)
           for (let i = 1; i < 5; i++) {
                 if(selectedTaxonomy[`level_${i}`])
                  {
                    fetchTaxonomyValues({level: i+1,
                    taxonomyLevel_1: selectedTaxonomy.level_1 || null,
                    taxonomyLevel_2: selectedTaxonomy.level_2 || null,
                    taxonomyLevel_3: selectedTaxonomy.level_3 || null,
                    taxonomyLevel_4: selectedTaxonomy.level_4 || null}
                    , selectedTaxonomy)
                }
            }
        } else {
            fetchTaxonomyValues(initialValueValues)
        }
    },[])

    async function fetchTaxonomyValues(body, taxonomy){
        const result = await baseRequest({body}, dispatch, QUERY_POST_TAXONOMY, "POST");
        setTaxonomyOptions(prevState=>({...prevState, [`level_${result.level}`]: result.values}) );
        if(taxonomy){
            setSelectedValues(prevState=>({...prevState, [`taxonomyLevel_${result.level}`]: taxonomy[`level_${result.level}`] }))
        }  
    } 

    function onValueChange(newValue, level){
                let newFilterValues = {...selectedValues, level, [`taxonomyLevel_${level-1}`]: newValue }
                for(let i = level; i<5; i++){
                    newFilterValues = {...newFilterValues, [`taxonomyLevel_${i}`]: null}
                }
                fetchTaxonomyValues(newFilterValues);
                setSelectedValues(newFilterValues);
                handleTaxonomiesChange(newFilterValues, selectedTaxonomy?.externalId)
        }
        
    return(
        <div style={{display: "grid", gridTemplateColumns: index > 0 ? "repeat(4, 1fr) 2.5rem" : "repeat(4, 1fr)" , columnGap: "1rem", alignItems: "center"}}>
            <SelectBox value={selectedTaxonomy?.level_1} showClearButton labelMode="floating" label="Taxonomía Nivel 1" onValueChanged={(e)=> {onValueChange(e.value, 2); valueLevel2.current.instance.reset()}} searchEnabled dataSource={taxonomyOptions.level_1} displayExpr="value" valueExpr={"key"}></SelectBox>
            <SelectBox value={selectedTaxonomy?.level_2} showClearButton innerRef={valueLevel2} labelMode="floating" label="Taxonomía Nivel 2" onValueChanged={(e)=> {onValueChange(e.value, 3); valueLevel3.current.instance.reset()}} disabled={!selectedTaxonomy?.level_1} searchEnabled dataSource={taxonomyOptions.level_2} displayExpr="value" valueExpr={"key"} ></SelectBox>
            <SelectBox value={selectedTaxonomy?.level_3} showClearButton innerRef={valueLevel3} labelMode="floating" label="Taxonomía Nivel 3" onValueChanged={(e)=> {onValueChange(e.value, 4); valueLevel4.current.instance.reset()}} disabled={!selectedTaxonomy?.level_2} searchEnabled dataSource={taxonomyOptions.level_3} displayExpr="value" valueExpr={"key"} ></SelectBox>
            <SelectBox value={selectedTaxonomy?.level_4} showClearButton innerRef={valueLevel4} labelMode="floating" label="Taxonomía Nivel 4" onValueChanged={(e)=> onValueChange(e.value, 5)} disabled={!selectedTaxonomy?.level_3} searchEnabled dataSource={taxonomyOptions.level_4} displayExpr="value" valueExpr={"key"}></SelectBox>
            {index > 0 ? 
            <div role="button" className="delete-icon-button" onClick={()=>handleDeleteTaxonomy(selectedTaxonomy.externalId)}><img height={30} src={deleteIcon}/> </div>
            : null
            }
        </div>
    )

}

export {TaxonomySelector}